/**
 * @description 对OpenGW的接口做一层抽象
 * @example  大括号被删除了
 * <file name="script.js">
 *     ...
 *     app.controller('someCtrl', function (OpenGW)
 *         OpenGW.getProductList(param).then(function (res)
 *             // response handle
 *         ).catch(function (err)
 *             // err handle
 *         )
 *     )
 * </file>
 */

define('services/common/ajax/openGW',['app'], function (app) {
    app.factory('OpenGW', ['auiAjaxWithError', function (auiAjaxWithError) {

        return {
            getAppInfo: auiAjaxWithError.curryOld('ogw.app.getAppInfo'),
            sendAppChangeNotice : auiAjaxWithError.curryOld('nsp.scope.app.sendAppChangeNotice'),
            nspScopeAppGet : auiAjaxWithError.curryOld('nsp.scope.app.get')
        };
    }]);
});
